import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Box, Footer as AdsFooter, Icon } from '@qbe/ads-core';
import React from 'react';

import { POLICY_WORDING_LINK, PRIVACY_LINK, TNC_LINK } from '~/constants/app';
import {
  FACEBOOK_URL,
  INSTAGRAM_URL,
  LINKEDIN_URL,
  X_URL,
  YOUTUBE_URL,
} from '~/constants/qbe-specific';
import { Z_INDEX } from '~/customTokens';

type FooterProps = { year?: number };

const currentYear = new Date().getFullYear();

const Footer = ({ year = currentYear }: FooterProps) => (
  <Box
    sx={{
      // FIXME - this should be resolved at ADS level
      zIndex: Z_INDEX.APP_FOOTER,
      position: 'relative',
    }}
  >
    <AdsFooter
      variant="compressed"
      customComponent={
        {
          title: 'Follow us',
          slot: [
            {
              title: 'LinkedIn',
              url: LINKEDIN_URL,
              component: <Icon muiIcon={LinkedInIcon} />,
              'data-track': 'linked-in',
              target: '_blank',
            },
            {
              title: 'Facebook',
              url: FACEBOOK_URL,
              component: <Icon muiIcon={FacebookIcon} />,
              'data-track': 'facebook',
              target: '_blank',
            },

            {
              title: 'YouTube',
              url: YOUTUBE_URL,
              component: <Icon muiIcon={YouTubeIcon} />,
              'data-track': 'youtube',
              target: '_blank',
            },
            {
              title: 'Instagram',
              url: INSTAGRAM_URL,
              component: <Icon muiIcon={InstagramIcon} />,
              'data-track': 'instagram',
              target: '_blank',
            },
            {
              title: 'X (formerly Twitter)',
              url: X_URL,
              component: <Icon muiIcon={XIcon} />,
              'data-track': 'twitter',
              target: '_blank',
            },
          ],
          // TODO - no support for target=_blank https://qbe-appservices.atlassian.net/browse/AD1-601
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } as any
      }
      linkColumns={
        [
          { title: `© Copyright QBE ${year}` },
          {
            title: 'Policy Wording',
            url: POLICY_WORDING_LINK,
            'data-track': 'policy-wording',
            target: '_blank',
          },
          {
            title: 'Privacy Policy',
            url: PRIVACY_LINK,
            'data-track': 'privacy-policy',
            target: '_blank',
          },
          { title: 'Terms of Use', url: TNC_LINK, 'data-track': 'terms', target: '_blank' },
          // TODO - casting error https://qbe-appservices.atlassian.net/browse/AD1-586
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ] as any
      }
      // TODO - element unused but required by type - https://qbe-appservices.atlassian.net/browse/AD1-587
    />
  </Box>
);

export default Footer;
